var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerificationButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06487 16.5C8.972 16.5 8.87913 16.4787 8.79532 16.4353L6.09449 15.0372C5.32812 14.6401 4.7286 14.1944 4.26047 13.6752C3.23587 12.5396 2.6658 11.082 2.65674 9.56993L2.62503 4.5932C2.62125 4.01882 2.99198 3.50327 3.54619 3.30912L8.50538 1.58009C8.79985 1.47492 9.12829 1.47345 9.42805 1.57494L14.4061 3.24513C14.9633 3.4312 15.3401 3.94307 15.3431 4.51671L15.3748 9.49712C15.3847 11.007 14.8342 12.4705 13.8255 13.6185C13.3626 14.1451 12.7684 14.5974 12.0096 15.0019L9.33291 16.4316C9.24986 16.4765 9.15774 16.4993 9.06487 16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48916 10.7407C8.34419 10.7414 8.19922 10.6892 8.08747 10.5818L6.64985 9.1992C6.42786 8.98445 6.4256 8.63585 6.64532 8.41963C6.86504 8.20268 7.22369 8.20047 7.44643 8.41448L8.48085 9.4088L11.0065 6.91859C11.227 6.70164 11.5856 6.69943 11.8076 6.91345C12.0304 7.12819 12.0326 7.47753 11.8129 7.69301L8.88858 10.5767C8.77834 10.6855 8.63413 10.7399 8.48916 10.7407Z",
    fill: "#76B545"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationButton);
export default __webpack_public_path__ + "static/media/verification-button.31bf81c9e6e3381a072b654e851c2850.svg";
export { ForwardRef as ReactComponent };